import {AfterViewInit, Component, Inject, Input, LOCALE_ID, OnDestroy} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CustomerOverViewService} from '~features/customer-overview/customer-overview.service';
import {SpinnerService} from '~shared/components/buttons/spinner/spinner.service';
import {TablesTranslations} from '~shared/components/tables/tables-translations.service';
import {CancellationTicket, Customer, InvoiceOrderStatus} from '~core/models';
import {InvoiceService} from '~core/services';
import {InvoiceOrderStatusTranslationsService} from '~shared/translations';


/**
 * Component class that displays the list of cancellations
 */
@UntilDestroy()
@Component({
  selector: 'app-customer-cancellations-list',
  templateUrl: './customer-cancellations-list.component.html',
  styleUrls: ['../../../customer-overview.component.scss']
})
export class CustomerCancellationsListComponent implements AfterViewInit, OnDestroy {
  public loading: boolean = true;
  public spinnerName: string = 'cancellationListLoading';
  public spinnerLoading: boolean;
  public invoiceList: Array<CancellationTicket> = [];
  public invoiceClass: Array<any> = [];
  public invoiceOrderStatus: InvoiceOrderStatus;

  public limitDisplayResults: number = 5;

  public columns: Array<string> = [];
  public keys: Array<Array<string>> = [];

  @Input() public customer: Customer;

  constructor(
    public customerService: CustomerOverViewService,
    public invoiceOrderStatusTranslations: InvoiceOrderStatusTranslationsService,
    public invoiceService: InvoiceService,
    public tablesTranslations: TablesTranslations,
    public spinnerService: SpinnerService,
    @Inject(LOCALE_ID) public locale: any
  ) {
    this.invoiceService.castCancellationsList.pipe(untilDestroyed(this))
      .subscribe(data => this.invoiceList = data);
    this.invoiceOrderStatus = new InvoiceOrderStatus(this.invoiceOrderStatusTranslations);
    this.invoiceList !== null ? this.spinnerLoading = false : this.spinnerLoading = true;

    this.columns.push(this.tablesTranslations.i18nDate, this.tablesTranslations.i18nCancellationNr,
      this.tablesTranslations.i18nInvoiceNr, this.tablesTranslations.i18nEventsAndTickets, this.tablesTranslations.i18nAmount);
    this.keys.push(['date', 'cancellationNumber', 'invoiceNumber', 'events', 'totalAmount'], ['', '', '', 'eventAndTicket', '']);
  }

  public ngAfterViewInit(): void {
    if (this.invoiceList === null) {
      this.invoiceService.getCustomerCancellations(this.customer.id).pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.invoiceService.setCancellationsList(res);
            this.spinnerService.hide(this.spinnerName);
          },
          error: (err: Error) => {
            this.spinnerService.hide(this.spinnerName);
          }
        });
    }
  }

  public ngOnDestroy(): void {
  }

  /**
   * Selects the invoice and opens it in the sidepanel
   */
  public openInvoice(invoice: any): void {
    this.customerService.toggleAllModal(false);
    this.customerService.toggleInvoicesModal(true);
    this.invoiceService.setSelectedInvoice(invoice);
  }

}
